import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

// /sso-callback — the OAuth/Enterprise-SSO redirect target.
//
// Clerk's <SignIn /> component (used in path-routing mode on /signin)
// redirects to this URL after an OAuth or SAML provider authenticates
// the user. The <AuthenticateWithRedirectCallback /> component calls
// `clerk.handleRedirectCallback(...)` internally, which:
//   1. completes the sign-in/up against Clerk's API,
//   2. sets the new session as active in the SDK,
//   3. navigates to the post-auth redirect target
//      (forceRedirectUrl / signInForceRedirectUrl).
//
// Why it's a top-level route (not nested under /_authenticated):
// Clerk hits this URL *before* the session is set — the request is the
// signed-in callback, not a visit to a protected page. Putting it
// behind the auth gate would race the session write and bounce the
// user to /signin mid-handshake.
//
// Why it's a top-level route (not nested under /_authenticated):
// Clerk hits this URL *before* the session is set — the request is the
// signed-in callback, not a visit to a protected page. Putting it
// behind the auth gate would race the session write and bounce the
// user to /signin mid-handshake. ClerkProvider is always mounted at
// this point, so the callback resolves cleanly.

export const Route = createFileRoute("/sso-callback")({
  component: SsoCallback,
});

function SsoCallback() {
  return <AuthenticateWithRedirectCallback />;
}
